export enum COMPARE_OPERATOR {
  EQUALS = 'Equals',
  STARTS_WITH = 'StartsWith',
  ENDS_WITH = 'EndsWith',
  CONTAINS = 'Contains',
}
